import {GridValueFormatterParams} from "@mui/x-data-grid";
import {formatDate, formatDateSimple, formatDateTime, humanFileSize} from "../../../utils/Date";
import { InvoiceState } from "../../Api/data/invoice/types";
import {OfferState} from "../../Api/data/offer/types";

export const dateFormatter = (params: GridValueFormatterParams<Date>) => {
    if (params.value == null) {
        return '';
    }
    else {
        return formatDateSimple(params.value);
    }
}

export const dateTimeFormatter = (params: GridValueFormatterParams<Date>) => {
    if (params.value == null) {
        return '';
    }
    else {
        return formatDateTime(params.value);
    }
}

export const fileSizeFormatter = (params: GridValueFormatterParams<Date>) => {
    if (params.value == null) {
        return '';
    }
    else {
        return humanFileSize(params.value)
    }
}
export const normalizeStateLabel = (state: OfferState) => {
    switch (state) {
        case OfferState.New:
            return "";
        case OfferState.QuoteSend:
            return "Nabídka";
        case OfferState.Ordered:
            return "Objednávka";
        case OfferState.Invoiced:
            return "Faktura";
        case OfferState.Paid:
            return "Zaplaceno";
        default:
            return state;
    }
}
export const normalizeInvoiceStateLabel = (state: InvoiceState) => {
    switch (state) {
        case InvoiceState.New:
            return "Nová";
        case InvoiceState.Send:
            return "Odesláno";
        case InvoiceState.Paid:
            return "Zaplaceno";
        default:
            return state;
    }
}